module.exports = {
    lang: {
        contextButtonTitle: '메뉴',
        downloadCSV: 'CSV로 다운로드',
        downloadJPEG: 'JPEG로 다운로드',
        downloadPDF: 'PDF로 다운로드',
        downloadSVG: 'SVG로 다운로드',
        downloadXLS: 'XLS로 다운로드',
        loading: '로딩중...',
        months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(val => `${val}월`),
        navigation: {
            popup: {
                addButton: '추가',
                arrowLine: '화살표'
            }
        },
        noData: '표시할 데이터가 없습니다.',
        numericSymbols: ['천', '백만', '십억', '조', '천조', '백경'],
        printChart: '인쇄',
        rangeSelectorFrom: '시작',
        rangeSelectorTo: '종료',
        rangeSelectorZoom: '기간',
        resetZoom: '기본값',
        resetZoomTitle: '기간 설정을 기본값으로 되돌립니다',
        shortMonths: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(val => `${val}월`),
        stockTools: {
            gui: {
                advanced: '고급',
                arrowLine: '화살표',
            }
        },
        thousandsSep: ',',
        weekdays: ['일', '월', '화', '수', '목', '금', '토'].map(val => `${val}요일`)
    }
}